export interface IPreviewCommentOrganization {
  id: string;
  name: string;
  bucketId: string;
}

class PreviewCommentOrganization {
  public readonly id: string;
  public readonly name: string;
  public readonly bucketId: string;

  constructor({ id, name, bucketId }: { id: string; name: string; bucketId: string }) {
    this.id = id;
    this.name = name;
    this.bucketId = bucketId;
  }

  public toJSON = () => ({
    id: this.id,
    name: this.name,
    bucketId: this.bucketId,
  });

  public static fromJSON = (json: IPreviewCommentOrganization): PreviewCommentOrganization => {
    const { id, name, bucketId } = Object.assign({}, json);

    if (typeof id !== 'string') throw new Error('.id must be a string');
    if (typeof name !== 'string') throw new Error('.name must be a string');
    if (typeof bucketId !== 'string') throw new Error('.bucketId must be a string');

    return new PreviewCommentOrganization({
      id,
      name,
      bucketId,
    });
  };
}

export default PreviewCommentOrganization;
